





















import { Component, Vue } from 'vue-property-decorator';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import { updateInfo } from '@/apis/myInfo/myInfo.ts';
import i18n from '@/lang';
@Component
export default class GradeModify extends Vue {
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }
  private stnoNumber: string = '';
  private columns: Array<string> = ['1', '2', '3', '4', '5', '6'];
  private show: boolean = false;
  keep() {
    updateInfo({
      username: this.userInfo.username,
      school: this.userInfo.school,
      department: this.userInfo.department,
      teachcourse: this.userInfo.teachcourse,
      stno: this.userInfo.stno,
      majors: this.userInfo.majors,
      classno: this.userInfo.additionInfo!.classno,
      enrolltime: this.userInfo.additionInfo!.enrolltime,
      grade: this.stnoNumber
    })
      .then(res => {
        this.$store.dispatch('setUserInfo').then(() => {
          this.$router.back();
        });
      })
      .catch(e => {});
  }
  //改变时
  onChange(e: any, val: any) {
    this.stnoNumber = val;
  }
  confirm(val: any) {
    this.stnoNumber = val;
    this.show = false;
  }
  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('CourseHome.年级') as string,
      showTitle: true
    });
    this.stnoNumber = this.userInfo!.additionInfo!.grade || i18n.t('CourseHome.未选择') as string;
  }
}
